var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c(_setup.SRideTypeSelection,{attrs:{"appConfig":_setup.appConfig,"rideType":_setup.getRideType,"animalsTransportation":_setup.getAnimalsTransportation,"availableShuttleType":_setup.getAvailableShuttleType},on:{"setRideType":_setup.setRideType}})
}
var staticRenderFns = []

export { render, staticRenderFns }